import store from '../../store';
import cookieManagerHelper from 'Helpers/cookies';
import { preNotificationCookie } from 'Actions/preNotification';

function getPreNotificationCookie() {
    const cookie = cookieManagerHelper.readCookie('preNotification');

    if (cookie && cookie !== 'undefined' && typeof cookie !== 'undefined') {
        store.dispatch(preNotificationCookie(true));
    }
    return cookie;
}

function setPreNotificationCookie() {
    const expirationDays = 1;

    store.dispatch(preNotificationCookie(true));
    cookieManagerHelper.createCookie('preNotification', true, expirationDays);
}

export {
    getPreNotificationCookie,
    setPreNotificationCookie
};
